<template>
  <div class="customerlist-expanded">
    <v-row class="rowSize1">
      <v-col>
        <span class="topData1"
          >{{ item.readiness }}<span style="font-size: 0.5em"></span>
          <span class="topDataBottom caption text-uppercase"
            >Readiness</span
          ></span
        >
        <canvas id="readiness_chart_doughnut" height="150" width="150"></canvas>
      </v-col>
      <v-col>
        <div class="topData2">
          {{ totalItems }}
          <div class="topDataBottom caption text-uppercase">Total Items</div>
        </div>
      </v-col>
      <div class="topData3">
        {{ totalResults }}
        <div class="topDataBottom caption text-uppercase">Total Results</div>
      </div>
    </v-row>
    <v-row class="rowSize2 no-gutters">
      <v-col
        ><canvas id="readiness_chart_bar" height="300" width="280"></canvas
      ></v-col>
      <v-col
        ><canvas id="items_chart_bar" height="300" width="280"></canvas
      ></v-col>
      <v-col
        ><canvas id="results_chart_bar" height="300" width="280"></canvas
      ></v-col>
    </v-row>
  </div>
</template>
<script>
import Chart from "chart.js";
import EventBus from "@/clients/event-bus";
import store from "../store/index";
export default {
  name: "customer-list-expanded-content",
  data: () => ({
    readiness_chart_doughnut: null,
    readiness_chart_bar: null,
    items_chart_bar: null,
    results_chart_bar: null,
  }),
  props: {
    clientId: {
      type: String,
      default: () => {
        return "client_id";
      },
    },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  beforeUnmount() {
    this.readiness_chart_doughnut.reset();
    this.readiness_chart_bar.reset();
    this.items_chart_bar.reset();
    this.results_chart_bar.reset();
  },
  mounted() {
    setTimeout(() => {
      this.create_readiness_chart_doughnut();
      this.create_chart_bar(
        "readiness_chart_bar",
        this.readiness_chart_bar,
        this.item.readiness_chart_values
      );
      this.create_chart_bar(
        "items_chart_bar",
        this.items_chart_bar,
        this.item.items_chart_values
      );
      this.create_chart_bar(
        "results_chart_bar",
        this.results_chart_bar,
        this.item.results_chart_values
      );
    }, 750);
  },
  computed: {
    progress() {
      return store.state.customerList.progress;
    },
    summary() {
      return store.state.customerList.summary;
    },
    readiness() {
      return store.state.customerList.readiness;
    },
    client() {
      const th = this;
      let client = {
        items_chart_values: [],
        readiness_chart_values: [],
        results_chart_values: [],
        readiness_value: null,
        readiness: null,
      };
      let totalItems = store.state.customerList.summary.filter(
        (sum) => sum.client_id == th.$route.params.clientId
      );

      if (totalItems.length == 1) {
        client.items_results = `${totalItems[0].total_items} / ${totalItems[0].total_results}`;
        client.total_items = totalItems[0].total_items;
        client.total_results = totalItems[0].total_results;
      }

      client.readiness_chart_values = this.readinessFiltered(
        th.$route.params.clientId
      );
      client.items_chart_values = this.itemsFiltered(th.$route.params.clientId);
      client.results_chart_values = this.resultsFiltered(
        th.$route.params.clientId
      );
      client.readiness_value = this.readinessPercentage(
        th.$route.params.clientId
      );

      let filtered = store.state.customerList.progress.filter((e) => e != null);
      if (
        filtered.filter((cus) => cus.client_id == th.$route.params.clientId)
          .length == 1
      ) {
        client.readiness =
          Number(
            filtered
              .filter((cus) => cus.client_id == th.$route.params.clientId)[0]
              .readiness.toFixed(0)
          ) + "%";
      } else {
        client.readiness = "0%";
      }

      return client;
    },
    noItems() {
      return store.state.customerList.noItems;
    },
    itemTypeOptions() {
      return this.itemTypes.map((e) => {
        return { text: e.description, value: e.id };
      });
    },
    itemTypes() {
      return store.state.customerList.itemTypes.sort(this.sortArray);
    },
    resultTypes() {
      return store.state.customerList.resultTypes;
    },
    customerName() {
      return store.state.customerList.customerName;
    },
    customerItems() {
      const items = store.state.customerList.items;
      const itemIcons = {
        5: "mdi-domain",
        2: "mdi-web",
        3: "mdi-server-network",
        4: "mdi-wan",
        20: "mdi-cellphone-text",
        6: "mdi-email",
        1: "mdi-ip-network",
        26: "mdi-spider-thread",
      };

      const customIcons = {
        8: "emaildomain",
        7: "emailhost",
      };

      for (const item of items) {
        item.icon = itemIcons[item.item_type.id];
        item.customIcon = customIcons[item.item_type.id];
      }

      return items;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    summaryItemCount() {
      const summary = store.state.customerList.summary[0];
      if (summary) {
        if (
          summary.items.filter((e) => e.item_type_name == this.currentType)
            .length == 1
        ) {
          return summary.items.filter(
            (e) => e.item_type_name == this.currentType
          )[0].count;
        } else {
          return 0;
        }
      }
    },

    totalItems() {
      const summary = store.state.customerList.summary || [];
      if (summary.length == 1) {
        return summary[0].total_items;
      }
    },
    totalResults() {
      const summary = store.state.customerList.summary || [];
      if (summary.length == 1) {
        return summary[0].total_results;
      }
    },
  },
  methods: {
    create_readiness_chart_doughnut() {
      let ctx = document.getElementById("readiness_chart_doughnut");
      let useColor;
      if (this.item.readiness_value >= 92) {
        useColor = ["rgba(71, 201, 84, 1)", "rgba(17, 39, 72, 1)"];
      } else {
        useColor = ["rgba(232, 96, 81, 1)", "rgba(17, 39, 72, 1)"];
      }
      this.readiness_chart_doughnut = new Chart(ctx, {
        type: "doughnut",
        data: {
          datasets: [
            {
              label: "Readiness",
              data: [
                this.item.readiness_value,
                100 - this.item.readiness_value,
              ],
              backgroundColor: useColor,
              borderColor: useColor,
              borderWidth: 1,
            },
          ],
        },
        options: {
          cutoutPercentage: 90,
          responsive: false,
          tooltips: {
            enabled: false,
          },
        },
      });
      this.readiness_chart_doughnut.update();
    },
    create_chart_bar(chartId, chartType, chartValues) {
      let ctx = document.getElementById(chartId);
      let th = this;
      /**Customize the Rectangle.prototype draw method**/
      Chart.elements.Rectangle.prototype.draw = function () {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var left, right, top, bottom, signX, signY, borderSkipped, radius;
        var borderWidth = vm.borderWidth;
        // If radius is less than 0 or is large enough to cause drawing errors a max
        //      radius is imposed. If cornerRadius is not defined set it to 0.
        var cornerRadius = this._chart.config.options.cornerRadius;
        var fullCornerRadius = this._chart.config.options.fullCornerRadius;
        var stackedRounded = this._chart.config.options.stackedRounded;
        var typeOfChart = this._chart.config.type;
        if (cornerRadius < 0) {
          cornerRadius = 0;
        }
        if (typeof cornerRadius == "undefined") {
          cornerRadius = 0;
        }
        if (typeof fullCornerRadius == "undefined") {
          fullCornerRadius = false;
        }
        if (typeof stackedRounded == "undefined") {
          stackedRounded = false;
        }
        if (!vm.horizontal) {
          // bar
          left = vm.x - vm.width / 2;
          right = vm.x + vm.width / 2;
          top = vm.y;
          bottom = vm.base;
          signX = 1;
          signY = bottom > top ? 1 : -1;
          borderSkipped = vm.borderSkipped || "bottom";
        } else {
          // horizontal bar
          left = vm.base;
          right = vm.x;
          top = vm.y - vm.height / 2;
          bottom = vm.y + vm.height / 2;
          signX = right > left ? 1 : -1;
          signY = 1;
          borderSkipped = vm.borderSkipped || "left";
        }
        // Canvas doesn't allow us to stroke inside the width so we can
        // adjust the sizes to fit if we're setting a stroke on the line
        if (borderWidth) {
          // borderWidth shold be less than bar width and bar height.
          var barSize = Math.min(
            Math.abs(left - right),
            Math.abs(top - bottom)
          );
          borderWidth = borderWidth > barSize ? barSize : borderWidth;
          var halfStroke = borderWidth / 2;
          // Adjust borderWidth when bar top position is near vm.base(zero).
          var borderLeft =
            left + (borderSkipped !== "left" ? halfStroke * signX : 0);
          var borderRight =
            right + (borderSkipped !== "right" ? -halfStroke * signX : 0);
          var borderTop =
            top + (borderSkipped !== "top" ? halfStroke * signY : 0);
          var borderBottom =
            bottom + (borderSkipped !== "bottom" ? -halfStroke * signY : 0);
          // not become a vertical line?
          if (borderLeft !== borderRight) {
            top = borderTop;
            bottom = borderBottom;
          }
          // not become a horizontal line?
          if (borderTop !== borderBottom) {
            left = borderLeft;
            right = borderRight;
          }
        }
        ctx.beginPath();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = borderWidth;
        // Corner points, from bottom-left to bottom-right clockwise
        // | 1 2 |
        // | 0 3 |
        var corners = [
          [left, bottom],
          [left, top],
          [right, top],
          [right, bottom],
        ];
        // Find first (starting) corner with fallback to 'bottom'
        var borders = ["bottom", "left", "top", "right"];
        var startCorner = borders.indexOf(borderSkipped, 0);
        if (startCorner === -1) {
          startCorner = 0;
        }
        function cornerAt(index) {
          return corners[(startCorner + index) % 4];
        }
        // Draw rectangle from 'startCorner'
        var corner = cornerAt(0);
        ctx.moveTo(corner[0], corner[1]);
        var nextCornerId, nextCorner, width, height, x, y;
        for (var i = 1; i < 4; i++) {
          corner = cornerAt(i);
          nextCornerId = i + 1;
          if (nextCornerId == 4) {
            nextCornerId = 0;
          }
          nextCorner = cornerAt(nextCornerId);
          width = corners[2][0] - corners[1][0];
          height = corners[0][1] - corners[1][1];
          x = corners[1][0];
          y = corners[1][1];
          var radius = cornerRadius;
          // Fix radius being too large
          if (radius > Math.abs(height) / 2) {
            radius = Math.floor(Math.abs(height) / 2);
          }
          if (radius > Math.abs(width) / 2) {
            radius = Math.floor(Math.abs(width) / 2);
          }
          var x_tl, x_tr, y_tl, y_tr, x_bl, x_br, y_bl, y_br;
          if (height < 0) {
            // Negative values in a standard bar chart
            x_tl = x;
            x_tr = x + width;
            y_tl = y + height;
            y_tr = y + height;
            x_bl = x;
            x_br = x + width;
            y_bl = y;
            y_br = y;
            // Draw
            ctx.moveTo(x_bl + radius, y_bl);
            ctx.lineTo(x_br - radius, y_br);
            // bottom right
            ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius);
            ctx.lineTo(x_tr, y_tr + radius);
            // top right
            fullCornerRadius
              ? ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr)
              : ctx.lineTo(x_tr, y_tr, x_tr - radius, y_tr);
            ctx.lineTo(x_tl + radius, y_tl);
            // top left
            fullCornerRadius
              ? ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius)
              : ctx.lineTo(x_tl, y_tl, x_tl, y_tl + radius);
            ctx.lineTo(x_bl, y_bl - radius);
            //  bottom left
            ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);
          } else if (width < 0) {
            // Negative values in a horizontal bar chart
            x_tl = x + width;
            x_tr = x;
            y_tl = y;
            y_tr = y;
            x_bl = x + width;
            x_br = x;
            y_bl = y + height;
            y_br = y + height;
            // Draw
            ctx.moveTo(x_bl + radius, y_bl);
            ctx.lineTo(x_br - radius, y_br);
            //  Bottom right corner
            fullCornerRadius
              ? ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius)
              : ctx.lineTo(x_br, y_br, x_br, y_br - radius);
            ctx.lineTo(x_tr, y_tr + radius);
            // top right Corner
            fullCornerRadius
              ? ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr)
              : ctx.lineTo(x_tr, y_tr, x_tr - radius, y_tr);
            ctx.lineTo(x_tl + radius, y_tl);
            // top left corner
            ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius);
            ctx.lineTo(x_bl, y_bl - radius);
            //  bttom left corner
            ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);
          } else {
            var lastVisible = 0;
            for (
              var findLast = 0, findLastTo = this._chart.data.datasets.length;
              findLast < findLastTo;
              findLast++
            ) {
              if (!this._chart.getDatasetMeta(findLast).hidden) {
                lastVisible = findLast;
              }
            }
            var rounded = this._datasetIndex === lastVisible;
            if (rounded) {
              //Positive Value
              ctx.moveTo(x + radius, y);
              ctx.lineTo(x + width - radius, y);
              // top right
              ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
              ctx.lineTo(x + width, y + height - radius);
              // bottom right
              if (fullCornerRadius || typeOfChart == "horizontalBar")
                ctx.quadraticCurveTo(
                  x + width,
                  y + height,
                  x + width - radius,
                  y + height
                );
              else
                ctx.lineTo(
                  x + width,
                  y + height,
                  x + width - radius,
                  y + height
                );
              ctx.lineTo(x + radius, y + height);
              // bottom left
              if (fullCornerRadius)
                ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
              else ctx.lineTo(x, y + height, x, y + height - radius);
              ctx.lineTo(x, y + radius);
              // top left
              if (fullCornerRadius || typeOfChart == "bar")
                ctx.quadraticCurveTo(x, y, x + radius, y);
              else ctx.lineTo(x, y, x + radius, y);
            } else {
              ctx.moveTo(x, y);
              ctx.lineTo(x + width, y);
              ctx.lineTo(x + width, y + height);
              ctx.lineTo(x, y + height);
              ctx.lineTo(x, y);
            }
          }
        }
        ctx.fill();
        if (borderWidth) {
          ctx.stroke();
        }
      };
      chartValues.type.forEach(function (part, index) {
        this[index] = th.truncateString(this[index], 18);
      }, chartValues.type);
      chartType = new Chart(ctx, {
        type: "horizontalBar",
        data: {
          labels: chartValues.type,
          datasets: [
            {
              label: "Readiness",
              data: chartValues.count,
              backgroundColor: chartValues.color,
              borderColor: chartValues.color,
              borderWidth: 1,
            },
          ],
        },
        options: {
          cornerRadius: 4,
          fullCornerRadius: true,
          stackedRounded: false,
          responsive: false,
          legend: {
            display: false,
          },
          layout: {
            padding: {
              left: 0,
              right: 20,
              top: 20,
              bottom: 20,
            },
          },
          tooltips: {
            titleFontSize: 12,
            bodyFontSize: 12,
            bodySpacing: 10,
            titleMarginBottom: 10,
            footerMarginTop: 10,
            mode: "label",
            callbacks: {
              label: function (tooltipItem, data) {
                if (chartId == "readiness_chart_bar") {
                  return (
                    data["datasets"][0]["data"][tooltipItem["index"]] + "%"
                  );
                } else {
                  return data["datasets"][0]["data"][tooltipItem["index"]];
                }
              },
            },
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  display: false,
                },
                type: "linear",
                display: false,
                gridLines: { display: false },
                scaleLabel: {
                  display: true,
                },
              },
            ],
            yAxes: [
              {
                type: "category",
                gridLines: { display: false },
                ticks: {
                  display: true,
                  drawOnChartArea: false,
                  color: "#112748",
                  lineWidth: 0,
                  fontSize: 11,
                  fontColor: "#fff",
                },
              },
            ],
          },
        },
      });
      chartType.update();
    },
    truncateString(str, num) {
      if (str.length <= num) {
        return str;
      }
      return str.slice(0, num) + "...";
    },
  },
};
</script>
<style scoped>
.customerlist-expanded {
  width: 100%;
  max-width: 936px;
  padding: 2em;
  background: #112748;
  margin-left: 0.8em;
  border-radius: 4px;
}
.topData1 {
  font-weight: 100;
  position: absolute;
  font-size: 2.2em;
  margin-left: 1.2em;
  margin-top: 1.2em;
}
.topData2 {
  font-weight: 100;
  margin-top: 1.2em;
  font-size: 2.2em;
}
.topData3 {
  font-weight: 100;
  margin-top: 1.2em;
  font-size: 2.5em;
}
.topDataBottom {
  display: flex;
  align-self: center;
  color: #d5d5d5;
}
.chartStyle {
  display: block;
  height: auto;
  width: 100%;
  border-radius: 4px;
  padding: 0.5em;
  z-index: 4;
  background: #112748;
}
.rowSize1 {
  max-width: 80%;
  margin-left: 5em;
}
.rowSize2 {
  max-width: 100%;
  margin: auto;
}
.manageIcons {
  right: 35px;
  position: absolute;
  color: #58abe7 !important;
}
</style>
